/**
 * Should be moved into respective utils/providers.
 */

export function normalizeCountryCode(countryCode) {
  return countryCode.toLowerCase()
}
export function normalizeLocale(locale) {
  return locale.toLowerCase()
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/utils/campaign.js